if (!customElements.get('product-sub-header')) {
    customElements.define('product-sub-header', class ProductHeader extends HTMLElement {
        constructor() {
            super();
            this.initProductHeader();
        }

        initProductHeader() {
            let animating = false,
                navLinks = document.querySelectorAll('.product-sub-header .links a');

            var positions = {};

            for (var i = 0; i < navLinks.length; i++) {
                let name = navLinks[i].getAttribute('href').split('#')[1],
                    anchor = document.querySelector('a[name="' + name + '"]');
                if (anchor) {
                    positions[name] = anchor.getBoundingClientRect().top - 80;
                }
            }  

            const windowWidth = window.innerWidth;

            window.addEventListener('resize', function (e) {
                let navLinks = document.querySelectorAll('.product-sub-header .links a');

                if (windowWidth !== window.innerWidth) {
                    for (var i = 0; i < navLinks.length; i++) {
                        let name = navLinks[i].getAttribute('href').split('#')[1],
                            anchor = document.querySelector('a[name="' + name + '"]');
                        if (anchor) {
                            positions[name] = anchor.getBoundingClientRect().top - 80;
                        }
                    }
                }
            });

            window.addEventListener('scroll', function (e) {
                if (animating) {
                    return false;
                }


                for (var i = 0; i < navLinks.length; i++) {
                    let name = navLinks[i].getAttribute('href').split('#')[1],
                        anchor = document.querySelector('.' + name);
                    if (anchor) {
                        positions[name] = anchor.getBoundingClientRect().top - 80;
                    }
                }

                let topDistance = window.pageYOffset,
                    show = positions['ingredients'],
                    currentActive = document.querySelector('.product-sub-header .selected'),
                    productSubHeader = document.querySelector('.product-sub-header');

                if (currentActive) {
                    currentActive = document.querySelector('.product-sub-header .links .buy');
                }

                if (topDistance >= show) {
                    productSubHeader.classList.add('product-sub-header-show');
                    let selected;
                    for (var key in positions) {
                        if (positions[key] <= topDistance) {
                            selected = key;
                        }
                    }

                    let newActive = document.querySelector('.navbar .links a[href*="' + selected + '"]');
                    if (currentActive !== newActive) {
                        currentActive.classList.remove('selected');
                        newActive.classList.add('selected');
                    }
                } else {
                    productSubHeader.classList.remove('product-sub-header-show');
                }

            });

            navLinks.forEach((item, index) => {
                var productSubHeader = document.querySelector('.product-sub-header');

                item.addEventListener('click', function (e) {
                    e.preventDefault();
                    let linkHref = this.getAttribute('href'),
                        name = linkHref.split('#')[1],
                        target = document.querySelector('.' + name),
                        currentActive = document.querySelector('.product-sub-header .links .selected');

                    if (currentActive) {
                        currentActive.classList.remove('selected');
                    }

                    if (name === 'buy') {
                        productSubHeader.classList.remove('product-sub-header-show')
                    }

                    productSubHeader.classList.remove('product-sub-header-show')
                    item.classList.add('selected');
                    window.scrollBy({
                        top: target.getBoundingClientRect().top - 120,
                        behavior: 'smooth',
                    });

                });

            })
        

        }

    });
}

const goToSelector = () => {
  let productSelector = document.querySelector('.benefits');
  productSelector.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  return true;
}      
